// lib/personal/rechte.ts
// #548: Wer darf Zeiterfassung, Abwesenheiten, Personalakte und Monatsabschluss für ALLE verwalten?
// Admins immer, dazu Personen mit profiles.darf_personal_verwalten (DB: darf_zeiten_verwalten()).

export function darfPersonalVerwalten(profil: { role?: string | null; darf_personal_verwalten?: boolean | null } | null | undefined): boolean {
  const rolle = (profil?.role || '').toLowerCase();
  return ['admin', 'super admin', 'master admin'].includes(rolle) || profil?.darf_personal_verwalten === true;
}

// Gewählter Mitarbeiter bleibt beim Wechsel zwischen Zeiterfassung und Personalakte erhalten
// (Sitzung des Browser-Tabs; ohne Speicher einfach der eigene Name).
const SCHLUESSEL = 'personal_gewaehlter_mitarbeiter';
export function gemerkterMitarbeiter(): string | null {
  try { return sessionStorage.getItem(SCHLUESSEL); } catch { return null; }
}
export function merkeMitarbeiter(id: string | null | undefined): void {
  try { if (id) sessionStorage.setItem(SCHLUESSEL, id); } catch { /* ohne Speicher kein Merken */ }
}
